module.exports = __webpack_public_path__ + "static/media/profile-default.e10efec8.jpg";